const scrollLockClass = 'jg-page-scroll-lock';
const scrollOffsetVar = '--jg-scroll-offset';
const scrollOffsetStickyClass = 'js-jg-scroll-offset-sticky';
const scrollOffsetStickyVar = '--jg-scroll-offset-sticky';

let cachedRootStyles = null;

function emitDialogCloseEvent(event) {
    const dialog = event.target;
    const customEvent = new CustomEvent('dialogClosed', {
        detail: { dialog }
    });
    document.dispatchEvent(customEvent);
}

function lockPageScroll() {
    document.documentElement.style.setProperty(scrollOffsetVar, window.scrollY);
    
    // Calculate total vertical size for sticky elements
    const stickyElements = document.querySelectorAll(`.${scrollOffsetStickyClass}`);
    let totalVerticalSize = 0;
    
    stickyElements.forEach(element => {
        const styles = window.getComputedStyle(element);
        const height = element.offsetHeight;
        const marginTop = parseFloat(styles.marginTop);
        const marginBottom = parseFloat(styles.marginBottom);
        
        // Add height and vertical margins to total
        totalVerticalSize += height + marginTop + marginBottom;
    });
    
    // Apply total vertical size to the CSS variable
    document.documentElement.style.setProperty(scrollOffsetStickyVar, `${totalVerticalSize}px`);
    
    document.documentElement.classList.add(scrollLockClass); 
}

function unlockPageScroll() {
    const scrollY = parseInt(getCSSCustomProperty(scrollOffsetVar, true));
    document.documentElement.classList.remove(scrollLockClass);
    window.scrollTo({ top: scrollY, behavior: 'instant' });
}

/**
* Fetches the value of a CSS custom property (variable) from :root
* @param {string} propertyName - The name of the CSS custom property (e.g., '--jg-media-bp-xsmall')
* @param {boolean} forceUpdate - If true, recalculates and updates the cache
* @return {string} - The value of the CSS custom property
*/
function getCSSCustomProperty(propertyName, forceUpdate = false) {
    if (!cachedRootStyles || forceUpdate) {
        cachedRootStyles = getComputedStyle(document.documentElement);
    }
    return cachedRootStyles.getPropertyValue(propertyName).trim();
}

export {
    emitDialogCloseEvent,
    lockPageScroll,
    unlockPageScroll,
    getCSSCustomProperty
};
